// extracted by mini-css-extract-plugin
export default {"premiumBadge":"ExternalServiceCard-module__premiumBadge--NM0kO"};